// Constants
import { VARIANTS } from '@openbank/ziniaweb-ui-components';
// Types
import { LayoutFooterHookType } from '../hooks/types/layout-footer.hook.type';
import { LayoutMainButtonConfigurationType } from 'types/layout-main-button-configuration.type';

const buttonConfigurationIsLegit = (
  buttonConfiguration: LayoutFooterHookType['buttonConfiguration']
): boolean => (buttonConfiguration as LayoutMainButtonConfigurationType)?.onClick !== undefined;

const getLayoutFooterVariant = (
  buttonConfiguration: LayoutFooterHookType['buttonConfiguration']
):
  | typeof VARIANTS.FooterVariantsType.ACTION_BUTTONS
  | typeof VARIANTS.FooterVariantsType.ONE_ACTION =>
  buttonConfigurationIsLegit(buttonConfiguration)
    ? VARIANTS.FooterVariantsType.ACTION_BUTTONS
    : VARIANTS.FooterVariantsType.ONE_ACTION;

export { buttonConfigurationIsLegit, getLayoutFooterVariant };
